module.exports = __webpack_public_path__ + "media/images/features/6/schedule-1-d1a7db54d2f0ec2350de7b2e88613980.png";